import React, { useEffect, useState } from "react";
import { Button, PlusIcon, TrashIcon } from "evergreen-ui";
import { Table, Card, Input, Popconfirm } from "antd";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import FireFetch from "../../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { getDatabase, ref } from "firebase/database";
import { EyeFilled } from "@ant-design/icons";
import RoleDetails from "../../userRolesDetails";
import TableActionMenu from "../../../Common/TableActionMenu";

const { Search } = Input;
const db = getDatabase(Firebase);

const UserRolesLayout = (props) => {
	const canCreate = props.canCreate !== false;
	const canUpdate = props.canUpdate !== false;
	const canDelete = props.canDelete !== false;
	const columns = [
		{
			title: "Role",
			dataIndex: "role",
			key: "role",
			sorter: (a, b) => a.role && a.role.localeCompare(b.role),
		},
		{
			title: "Description",
			dataIndex: "description",
			key: "description",
			sorter: (a, b) =>
				a.description && a.description.localeCompare(b.description),
		},
		{
			title: "Action",
			dataIndex: "action",
			key: "action",
		},
	];

	const [rolesList, setRolesList] = useState([]);
	const [dataArray, setDataArray] = useState([]);
	const [arrayIn, loading] = useListVals(ref(db, "talmidsdb/userRoles"));
	const [selectedRoleId, setSelectedRoleId] = useState(null);

	useEffect(() => {
		if (arrayIn) {
			const tempArray = arrayIn.map((item, index) => ({
				key: index,
				id: item.id,
				role: item.roleName,
				description: item.description,
				action: (
					<TableActionMenu
						items={[
							{
								key: "view",
								label: "View",
								onClick: () => {
									setSelectedRoleId(item.roleName);
								},
							},
							canDelete && {
								key: "delete",
								label: "Delete",
								danger: true,
								onClick: () => {
									if (confirm("Are you sure you want to delete this role?")) {
										props.messageBack("userRoles", "delete", item.id);
									}
								},
							},
						]}
					/>
				),
			}));

			setRolesList(tempArray);
			setDataArray(tempArray);
		}
	}, [arrayIn, props, canDelete]);

	const handleSearch = (searchText) => {
		const query = (searchText || "").toLowerCase();

		const filtered = dataArray.filter(({ id, role }) => {
			const idStr = id && String(id).toLowerCase();
			const roleStr = role && role.toLowerCase();

			return (
				(idStr && idStr.includes(query)) ||
				(roleStr && roleStr.includes(query))
			);
		});

		setRolesList(filtered);
	};

	if (selectedRoleId) {
		return (
			<RoleDetails
				roleId={selectedRoleId}
				onBack={() => setSelectedRoleId(null)}
				canUpdate={canUpdate}
			/>
		);
	}

	// Otherwise show the roles table
	return (
		<div className="font-Nunito">
			<div>
				{canCreate && (
					<Button
						appearance="primary"
						className="ml-3 my-2"
						onClick={() => {
							props.messageBack("userRoles", "create");
						}}
					>
						New Role <PlusIcon />
					</Button>
				)}

				<Button
					appearance="primary"
					className="ml-3 my-2"
					onClick={() => {
						FireFetch.exportXL(
							TableExport(document.getElementById("dataTable"), {
								filename: "User Roles",
								exportButtons: false,
								sheetname: "UserRoles",
							}),
							rolesList
						);
					}}
				>
					Print
				</Button>

				<Search
					className="ml-3 my-2"
					style={{ width: "16rem" }}
					placeholder="Filter User roles"
					onChange={(e) => handleSearch(e.target.value)}
				/>
			</div>

			<Card className="d-flex flex-column">
				<div>
					<Table
						style={{ overflow: "auto" }}
						loading={loading}
						className="custom-table"
						pagination={{
							defaultPageSize: 100,
							showSizeChanger: true,
							pageSizeOptions: ["20", "50", "100"],
						}}
						id="dataTable"
						dataSource={rolesList}
						columns={columns}
					/>
				</div>
			</Card>
		</div>
	);
};

export default UserRolesLayout;
